import React, { useState, useEffect } from 'react';
import { LoginImport } from './Imports';
const { LoginBanner, LoginBanner1, Logo, UserLoginForm, ForgetPasswordForm, AOS, } = LoginImport;

export default function UserLogin() {
    const [toggle, setToggle] = useState(false);

    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <section className="login-page-wrapper">
            <div className="login-hero">
                <div className="brand-chip" data-aos="fade-right">
                    <img src={Logo} alt="Techlene logo" />
                    <span>Asset Maintenance</span>
                </div>

                <div className="hero-copy" data-aos="fade-up">
                    <p className="eyebrow">Welcome back</p>
                    <h4 className='text-white'>
                        A smarter way to track, plan and protect every asset in your
                        ecosystem.
                    </h4>
                    <p className="lead">
                        Centralized dashboards, predictive maintenance reminders and instant
                        collaboration help you deliver reliability with confidence.
                    </p>
                    <ul className="benefits-list">
                        <li>Realtime asset health & incident timelines</li>
                        <li>Automated maintenance workflows </li>
                        <li>Enterprise-grade security powered by Techlene</li>
                    </ul>
                </div>

                <div className="hero-illustration" data-aos="zoom-in" style={{ opacity: 0.5 }}>
                    <img src={LoginBanner} alt="Maintenance illustration" />
                </div>

                <p className="credit-line">
                    Developed by{' '}
                    <button
                        type="button"
                        onClick={() => window.open('https://www.techlene.com/', '_blank')}
                    >
                        Techlene Software Solutions Pvt. Ltd.
                    </button>
                </p>
            </div>

            <div className="login-panel" data-aos="fade-left">
                <div className="panel-header">
                    <img src={Logo} alt="logo" />
                    <div>
                        <p className="eyebrow">Access your workspace</p>
                        <h3 className='text-dark'>{toggle ? 'Reset password' : 'Login Securely'}</h3>
                    </div>
                </div>

                {!toggle ? (
                    <>
                        <UserLoginForm setToggle={setToggle} />
                        <div className="panel-links">
                            <button type="button" onClick={() => setToggle(true)}>
                                Forgot password?
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <ForgetPasswordForm setToggle={setToggle} />
                        <div className="panel-links">
                            <button type="button" onClick={() => setToggle(false)}>
                               Sign In
                            </button>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
}

